import CertificateTasksTable from './components/certificate-tasks-table/CertificateTasksTable';

const CertificateTasksTab = (): JSX.Element => {
  return (
    <div className='flex flex-column'>
      <CertificateTasksTable />
    </div>
  );
};

export default CertificateTasksTab;
